export const dataSets = {
  configuration: {
    createDataSet: "Data-Set anlegen"
  }
};
